import Spinner from '../global/Spinner'
import React from 'react'

const PnSpinner = ({className, style}) => {
    return (
        <div className={className} style={{...style, height:'80px',display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Spinner isLoading={true}  relative/>
        </div>
    )
}

export default PnSpinner;